import React from "react";
import MainTemplate from "../../../components/MainTemplate/MainTemplate";
import CardBackground from "../../../components/MainTemplate/CardBackground";
import RoleListChild from "./RoleListChild";

const RoleList = () => {
  return (
    <MainTemplate>
      <CardBackground>
        <RoleListChild />
      </CardBackground>
    </MainTemplate>
  );
};

export default RoleList;
